import { render } from "./LandscapeLayout.vue?vue&type=template&id=05ca42d0"
import script from "./LandscapeLayout.vue?vue&type=script&lang=js"
export * from "./LandscapeLayout.vue?vue&type=script&lang=js"

import "./LandscapeLayout.vue?vue&type=style&index=0&id=05ca42d0&lang=css"

import exportComponent from "/builds/kligmanbb/medsafe-smart-pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon});
